import DraggableTag from "./DraggableTag";

export default DraggableTag;
